import React, { PropsWithChildren, useState } from 'react';
import { useLocation } from 'react-router';
import { PostReplies } from './partials/PostReplies';

import { PostReplyForm } from './forms/PostReplyForm';
import { PostFirst, PostFirstTypes, PostFormTypes } from './Post.types';
import { Post } from './Post';
import { SonForm } from '../../Form2';
import { HeadingHierarchy } from '../Heading/Heading';

export type PostWithReplies = {
  post: PostFirst;
  index: number;
  headingHierarchy: HeadingHierarchy;
  previousPostId: string | undefined;
  type: PostFirstTypes;
};

export function PostWithReplies({
  index,
  headingHierarchy,
  previousPostId,
  children,
  post,
  type,
}: PropsWithChildren<PostWithReplies>) {
  const [currentForm, setCurrentForm] = useState<SonForm<PostFormTypes>>();

  const replyEditorId = `reply-editor-${post.id}`;
  const postNumber = index + 1;
  const { hash } = useLocation();

  return (
    <Post
      post={post}
      postNumber={postNumber}
      headingHierarchy={headingHierarchy}
      previousPostId={previousPostId}
      type={type}
      currentForm={currentForm}
      setCurrentForm={setCurrentForm}
      replyEditorId={replyEditorId}
    >
      {!(children && currentForm && currentForm === post.updateForm) && children}
      {post && (
        <>
          <PostReplies
            replies={post.replies}
            parentPostNumber={postNumber}
            previousPostId={previousPostId}
            currentForm={currentForm}
            setCurrentForm={setCurrentForm}
          />
          <div className="posts__skip-to-editor" id={replyEditorId} key={replyEditorId}>
            {hash.includes(replyEditorId) && post.replyForm && currentForm === post.replyForm && (
              <PostReplyForm type={type} post={post} setCurrentForm={setCurrentForm} />
            )}
          </div>
        </>
      )}
    </Post>
  );
}
